<!-- ALERT & CONFIRM DIALOG -->
<p-toast></p-toast>

<p-confirmDialog [style]="{width: '450px'}"></p-confirmDialog>

<!-- OVERLAY SCREEN-->
<div *ngIf="blocked " class="overlay">
    <img src="assets/layout/images/tovlogo.png" alt="{{translations.lbl_loading}}" class="loading-image" />
    <span style="color: white; font-size: large;">{{translations.lbl_loading}}</span>
</div>

<!-- MAIN CONTAINER -->
<div class="card" *ngIf="this.translations != null">

    <!-- TOOLBAR -->
    <p-toolbar styleClass="p-mb-4">
        <ng-template pTemplate="left">
            <!-- BACK BUTTON -->
            <button pButton pRipple label="{{translations.lbl_go_Back}}" icon="pi pi-chevron-left"
                class="p-button-warning p-mr-2" (click)="redirectSchoolFGParticipant()"></button>

            <!-- TRANSFER BUTTON ONLY WORK IF SCHOOLS SELECTED AND DOESNT HAVE STICKERS-->
            <button pButton pRipple type="button" icon="pi pi-send"
                [pTooltip]="translations.lbl_movement + ' ' + translations.lbl_of + ' ' + translations.lbl_future_guide"
                [ngStyle]="{'background-color': '#960018', 'border-color': '#960018', 'color': 'white'}"
                [disabled]="!(globalUserDataFormParams.get('selectedWorkshopEPGSchoolFpg').value !== null)"
                class="p-button-raised p-button-danger" (click)="openModelTransferGuideToNewCoordination()">
            </button>


        </ng-template>
    </p-toolbar>

    <!-- MAIN CONTENT -->
    <div class="p-grid">

        <!-- Coordinación Origen -->
        <div class="p-col-12 p-md-6">
            <p-panel [header]="translations.lbl_coordination + ' ' + translations.lbl_origin">
                <div class="p-fluid">
                    <ng-container *ngTemplateOutlet="infoTemplate"></ng-container>

                    <!-- SEPARADOR -->
                    <p-divider></p-divider>

                    <!-- COORDINACIONES -->
                    <ng-container
                        *ngTemplateOutlet="coordinationTemplate; context: {coord: 'selectedOriginCoord'}"></ng-container>
                </div>
            </p-panel>
        </div>

        <!-- Coordinación Destino -->
        <div class="p-col-12 p-md-6">
            <p-panel [header]="translations.lbl_destiny_coordination">
                <div class="p-fluid">
                    <ng-container *ngTemplateOutlet="infoTemplateFinalCoord"></ng-container>

                    <!-- SEPARADOR -->
                    <p-divider></p-divider>

                    <!-- COORDINACIONES -->
                    <ng-container
                        *ngTemplateOutlet="coordinationTemplate; context: {coord: 'selectedFinalCoord'}"></ng-container>
                </div>
            </p-panel>
        </div>

    </div>


    <!-- Template de información general -->
    <ng-template #infoTemplate>

        <!-- CHURCH INFO -->
        <div class="subTitle p-d-flex p-ai-center p-jc-between p-py-2">
            <span>{{ translations.lbl_church }}</span>
            <ng-container *ngIf="globalUserDataFormParams.get('selectedChurch').value != null; else noSelectionChurch">
                <span class="p-text-bold">
                    {{ globalUserDataFormParams.get('selectedChurch').value || " " }}</span>
            </ng-container>

            <ng-template #noSelectionChurch>
                <span class="p-text-bold">{{ translations.lbl_without + ' ' + translations.lbl_place + ' ' +
                    translations.lbl_and + '/' + translations.lbl_or + ' ' + translations.lbl_church + ' ' +
                    translations.lbl_select}}</span>
            </ng-template>
        </div>

        <!-- SERVICE INFO -->
        <div class="subTitle p-d-flex p-ai-center p-jc-between p-py-2">
            <span>{{ translations.lbl_workshop }}</span>
            <ng-container
                *ngIf="globalUserDataFormParams.get('selectedService').value != null; else noSelectionService">
                <span class="p-text-bold">
                    {{ globalUserDataFormParams.get('selectedService').value || " " }}</span>
            </ng-container>

            <ng-template #noSelectionService>
                <span class="p-text-bold">{{ translations.lbl_without + ' ' + translations.lbl_service + ' ' +
                    translations.lbl_select}}</span>
            </ng-template>
        </div>


        <!-- GUIDE ID INFO -->
        <div class="subTitle p-d-flex p-ai-center p-jc-between p-py-2">
            <span>{{ translations.lbl_guideId }}</span>
            <ng-container
                *ngIf="globalUserDataFormParams.get('selectedFutureGuide').value != null; else noSelectionGuide">
                <span class="p-text-bold">
                    {{
                    (globalUserDataFormParams.get('selectedFutureGuide').value?.guideId || '') +
                    ' - ' +
                    (globalUserDataFormParams.get('selectedFutureGuide').value?.name || '') +
                    ' - ' +
                    (globalUserDataFormParams.get('selectedFutureGuide').value?.lastName || '')
                    }}</span>
            </ng-container>

            <ng-template #noSelectionGuide>
                <span class="p-text-bold">{{ translations.lbl_without + ' ' + translations.lbl_guide + ' ' +
                    translations.lbl_select}}</span>
            </ng-template>
        </div>

        <!-- PERIOD & YEAR INFO -->
        <div class="subTitle p-d-flex p-ai-center p-jc-between p-py-2">
            <span>{{ translations.lbl_period }}</span>
            <ng-container *ngIf="globalUserDataFormParams.get('selectedSchoolFpg').value != null; else noSelectionYear">
                <span class="p-text-bold">
                    {{
                    (globalUserDataFormParams.get('selectedSchoolFpg').value?.schoolFPG?.year || '') +
                    ' - ' +
                    (globalUserDataFormParams.get('selectedSchoolFpg').value?.schoolFPG?.period || '')
                    }}
                </span>
            </ng-container>

            <ng-template #noSelectionYear>
                <span class="p-text-bold">{{ translations.lbl_without + ' ' + translations.lbl_period + ' ' +
                    translations.lbl_and + '/' + translations.lbl_or + ' ' + translations.lbl_year + ' ' +
                    translations.lbl_select}}</span>
            </ng-template>
        </div>
    </ng-template>

    <!-- Template de información general -->
    <ng-template #infoTemplateFinalCoord>

        <!-- CHURCH INFO -->
        <div class="subTitle p-d-flex p-ai-center p-jc-between p-py-2">
            <span>{{ translations.lbl_church }}</span>
            <ng-container
                *ngIf="globalUserDataFormParams.get('selectedWorkshopEPGSchoolFpg').value != null && globalUserDataFormParams.get('selectedWorkshopEPG').value != null && globalUserDataFormParams.get('selectedWorkshopEPGSchoolFpg').value != null; else noSelectionChurchFinal">
                <span class="p-text-bold">
                    {{ globalUserDataFormParams.get('selectedWorkshopEPGSchoolFpg').value.schoolFPG?.schoolId || " " }}
                    -
                    {{ globalUserDataFormParams.get('selectedWorkshopEPGSchoolFpg').value.schoolFPG?.name || " " }} -
                    {{ globalUserDataFormParams.get('selectedWorkshopEPG').value.chr?.name || " " }}
                </span>
            </ng-container>

            <ng-template #noSelectionChurchFinal>
                <span class="p-text-bold">{{ translations.lbl_without + ' ' + translations.lbl_place + ' ' +
                    translations.lbl_and + '/' + translations.lbl_or + ' ' + translations.lbl_church + ' ' +
                    translations.lbl_select}}</span>
            </ng-template>
        </div>


        <!-- SERVICE INFO -->
        <div class="subTitle p-d-flex p-ai-center p-jc-between p-py-2">
            <span>{{ translations.lbl_workshop }}</span>
            <ng-container
                *ngIf="globalUserDataFormParams.get('selectedWorkshopEPG').value != null  && globalUserDataFormParams.get('selectedWorkshopEPGSchoolFpg').value  != null; else noSelectionServiceFinal">
                <span class="p-text-bold">
                    {{ globalUserDataFormParams.get('selectedWorkshopEPGSchoolFpg').value.schoolFPG?.name || " " }} -
                    {{ globalUserDataFormParams.get('selectedWorkshopEPG').value?.f0?.wrksId || " " }}
                    {{ globalUserDataFormParams.get('selectedWorkshopEPG').value?.wst?.wsName || " " }}
                </span>
            </ng-container>

            <ng-template #noSelectionServiceFinal>
                <span class="p-text-bold">{{ translations.lbl_without + ' ' + translations.lbl_service + ' ' +
                    translations.lbl_select}}</span>
            </ng-template>
        </div>

        <!-- GUIDE ID INFO -->
        <div class="subTitle p-d-flex p-ai-center p-jc-between p-py-2">
            <span>{{ translations.lbl_guideId }}</span>
            <ng-container
                *ngIf="globalUserDataFormParams.get('selectedFutureGuide').value != null; else noSelectionGuideFinal">
                <span class="p-text-bold">
                    {{ globalUserDataFormParams.get('selectedFutureGuide').value?.guideId || " " }} -
                    {{ globalUserDataFormParams.get('selectedFutureGuide').value?.name || " " }} -
                    {{ globalUserDataFormParams.get('selectedFutureGuide').value?.lastName || " " }}
                </span>
            </ng-container>

            <ng-template #noSelectionGuideFinal>
                <span class="p-text-bold">{{ translations.lbl_without + ' ' + translations.lbl_guide + ' ' +
                    translations.lbl_select}}</span>
            </ng-template>
        </div>

        <!-- PERIOD & YEAR INFO -->
        <div class="subTitle p-d-flex p-ai-center p-jc-between p-py-2">
            <span>{{ translations.lbl_period }}</span>
            <ng-container
                *ngIf="globalUserDataFormParams.get('selectedWorkshopEPG').value != null  && globalUserDataFormParams.get('selectedWorkshopEPGSchoolFpg').value != null; else noSelectionYearFinal">
                <span class="p-text-bold">
                    {{ globalUserDataFormParams.get('selectedWorkshopEPG').value?.f0?.anio || " " }} -
                    {{ globalUserDataFormParams.get('selectedWorkshopEPG').value?.f0?.period || " " }}
                </span>
            </ng-container>

            <ng-template #noSelectionYearFinal>
                <span class="p-text-bold">{{ translations.lbl_without + ' ' + translations.lbl_period + ' ' +
                    translations.lbl_and + '/' + translations.lbl_or + ' ' + translations.lbl_year + ' ' +
                    translations.lbl_select}}</span>
            </ng-template>
        </div>
    </ng-template>

    <!-- Template de coordinación -->
    <ng-template #coordinationTemplate let-coord="coord">
        <div class="subTitle p-d-flex p-ai-center p-jc-between p-py-2"
            *ngIf="globalUserDataFormParams.get('selectedSchoolFpg').value && globalUserDataFormParams.get('selectedFutureGuide').value">
            <span>{{ translations.lbl_coordination }} {{ translations.lbl_zonal }} </span>
            <span class="p-text-bold">
                {{ globalUserDataFormParams.get(coord).value?.sup2Descri || (translations.lbl_without + ' ' +
                translations.lbl_zonal_coordination + ' ' + translations.lbl_select) }}
            </span>
        </div>

        <div class="subTitle p-d-flex p-ai-center p-jc-between p-py-2"
            *ngIf="globalUserDataFormParams.get('selectedSchoolFpg').value && globalUserDataFormParams.get('selectedFutureGuide').value">
            <span>{{ translations.lbl_coordination }} {{ translations.lbl_natio }} </span>
            <span class="p-text-bold">
                {{ globalUserDataFormParams.get(coord).value?.sup1Descri || (translations.lbl_without + ' ' +
                translations.lbl_national_coordination + ' ' + translations.lbl_select) }}
            </span>
        </div>

        <div class="subTitle p-d-flex p-ai-center p-jc-between p-py-2"
            *ngIf="globalUserDataFormParams.get('selectedSchoolFpg').value && globalUserDataFormParams.get('selectedFutureGuide').value">
            <span>{{ translations.lbl_coordination }} {{ translations.lbl_local }} </span>
            <span class="p-text-bold">
                {{ globalUserDataFormParams.get(coord).value?.descri || (translations.lbl_without + ' ' +
                translations.lbl_local_coordination + ' ' + translations.lbl_select) }}
            </span>
        </div>
    </ng-template>


    <!-- FORM TRANSFER -->
    <div class="card">
        <div class="p-grid p-fluid" [formGroup]="globalUserDataFormParams">

            <!-- COORDINATION INPUT DROPDOWN -->
            <div class="p-col-12 p-md-6">
                <label for="statusModal">
                    {{ translations.lbl_select }} {{ translations.lbl_coordination }} {{ translations.lbl_destination }}
                    <span class="text-danger">(*)</span>
                </label>

                <ng-container>
                    <p-autoComplete formControlName="selectedFinalCoord"
                        [suggestions]="globalUserDataFormParams.get('selectedStoreListSuggestions').value"
                        (completeMethod)="filterSupRelationList($event)" field="descri" [minLength]="1"
                        (onSelect)="updateFinalEPG($event)" [dropdown]="true">
                    </p-autoComplete>
                </ng-container>
            </div>

        </div>

        <!-- TABLE -->
        <p-table #dt2 [value]="globalUserDataFormParams.get('selectedOpenAssignedFolios').value"
            *ngIf="globalUserDataFormParams.get('selectedOpenAssignedFolios').value != null"
            [columns]="lstColsOpenFolios" selectionMode="single" dataKey="assignedFolio.itemId" [rows]="5"
            [paginator]="true" [rowsPerPageOptions]="[5, 10, 20]"
            [globalFilterFields]="['assignedFolio.itemId','assignedFolio.descri']" [rowHover]="true"
            currentPageReportTemplate="{{translations.lbl_showing}} {first} {{translations.lbl_of}} {last} {{translations.lbl_records}}"
            [showCurrentPageReport]="true" responsive="true">

            <!-- CAPTION -->
            <ng-template pTemplate="caption">
                <div class="p-d-flex p-ai-center p-jc-between">
                    <h5 class="p-m-0">{{ translations.lbl_pending + ' ' + translations.lbl_return + ' ' +
                        translations.lbl_manual_number}}
                    </h5>

                    <span class="p-input-icon-left">
                        <i class="pi pi-search"></i>
                        <input pInputText type="text" (input)="dt2.filterGlobal($event.target.value, 'contains')"
                            placeholder="{{translations.lbl_search}}..." />
                    </span>
                </div>
            </ng-template>

            <!-- HEADER -->
            <ng-template pTemplate="header">
                <tr>
                    <th pSortableColumn="assignedFolio.itemId" pTooltip="{{ translations.lbl_id }}">
                        {{ translations.lbl_id }} <p-sortIcon field="assignedFolio.itemId"></p-sortIcon>
                    </th>
                    <th colspan="3" pSortableColumn="assignedFolio.descri"
                        pTooltip="{{ translations.lbl_description }}">
                        {{ translations.lbl_description }} <p-sortIcon field="assignedFolio.descri"></p-sortIcon>
                    </th>
                </tr>
            </ng-template>

            <!-- BODY -->
            <ng-template pTemplate="body" let-data>
                <tr>
                    <td pTooltip="{{ data.assignedFolio.itemId || '-' }}">{{ data.assignedFolio.itemId ||
                        '-' }}</td>
                    <td colspan="3" pTooltip="{{ data.assignedFolio.descri || '-' }}">{{ data.assignedFolio.descri ||
                        '-' }}</td>
                </tr>

                <!-- SUB TABLE -->
                <tr>
                    <td colspan="1"></td>
                    <td colspan="3" class="sub-table-container">

                        <table class="small-table" responsive="true" value="data.assignedFolios">

                            <!-- HEADER SUB TABLE-->
                            <thead>
                                <tr>
                                    <th pTooltip="{{ translations.lbl_manual_number }}"
                                        data-label="{{ translations.lbl_manual_number }}">{{
                                        translations.lbl_manual_number}}</th>
                                    <th pTooltip="{{ translations.lbl_delivery_date }}"
                                        data-label="{{ translations.lbl_delivery_date }}">{{
                                        translations.lbl_delivery_date}}</th>
                                    <th pTooltip="{{ translations.lbl_returning_date }}"
                                        data-label="{{ translations.lbl_returning_date }}">{{
                                        translations.lbl_returning_date}}</th>
                                </tr>
                            </thead>

                            <!-- BODY SUB TABLE -->
                            <tbody>
                                <ng-container *ngIf="data.assignedFolios?.length > 0; else emptyMessage">
                                    <tr *ngFor="let item of data.assignedFolios" class="p-mb-4">

                                        <td class="align-end"
                                            pTooltip="{{ item?.id?.folio || (translations?.lbl_without + ' ' + translations?.lbl_manual_number) }}"
                                            [attr.data-label]="translations?.lbl_manual_number">
                                            {{ item?.id?.folio || (translations?.lbl_without + ' ' +
                                            translations?.lbl_manual_number) }}
                                        </td>


                                        <td class="align-end"
                                            pTooltip="{{ item?.id?.folio || (translations?.lbl_without + ' ' + translations?.lbl_delivery_date) }}"
                                            [attr.data-label]="translations?.lbl_delivery_date">
                                            {{ item?.assigDate ? formatDate(item?.assigDate) :
                                            (translations?.lbl_delivery_date + ' ' + translations?.lbl_without + ' ' +
                                            translations?.lbl_delivery_date) }}
                                        </td>

                                        <td class="align-end"
                                            pTooltip="{{ item?.id?.folio || (translations?.lbl_without + ' ' + translations?.lbl_returning_date) }}"
                                            [attr.data-label]="translations?.lbl_returning_date">
                                            {{ item?.returnDate ? formatDate(item?.returnDate) :
                                            translations?.lbl_without + ' ' +
                                            translations?.lbl_returning_date }}
                                        </td>

                                    </tr>
                                </ng-container>
                            </tbody>

                            <!-- EMPTY MESSAGE -->
                            <ng-template #emptyMessage>
                                <tr>
                                    <td colspan="6" class="text-center">
                                        {{ translations.lbl_no_records_found }}
                                    </td>
                                </tr>
                            </ng-template>

                        </table>

                    </td>
                </tr>
            </ng-template>

            <!-- EMPTY -->
            <ng-template pTemplate="emptymessage" let-columns>
                <tr>
                    <td [attr.colspan]="columns ? columns.length : 1">
                        {{translations.lbl_no_records_found}}
                    </td>
                </tr>
            </ng-template>

            <!-- SUMMARY -->
            <ng-template pTemplate="summary">
                <div class="p-d-flex">
                    <span class="p-mr-2">{{ translations.lbl_total }}</span>
                    <span class="p-text-bold p-mr-2">
                        {{ (globalUserDataFormParams.get('selectedOpenAssignedFolios').value).length || 0 }}
                    </span>
                    <span>{{ translations.lbl_records }}</span>
                </div>
            </ng-template>
        </p-table>

        <!-- GAP -->
        <br /><br />

        <!-- TABLE -->
        <p-table #dt [value]="globalUserDataFormParams.get('selectedLstEpgByFinalCord').value" [columns]="lstCols"
            selectionMode="single" dataKey="wrksId" [rows]="5" [paginator]="true" [rowsPerPageOptions]="[5, 10, 20]"
            [globalFilterFields]="['schoolFPG.period','schoolFPG.year','schoolFPG.name','guideName','schoolFPG.planedDate','storeName','statusName','schoolFPG.schoolId']"
            [rowHover]="true"
            currentPageReportTemplate="{{translations.lbl_showing}} {first} {{translations.lbl_of}} {last} {{translations.lbl_records}}"
            [showCurrentPageReport]="true" responsive="true"
            *ngIf="globalUserDataFormParams.get('selectedLstEpgByFinalCord').value != null"
            [expandedRowKeys]="expandedRows">


            <!-- CAPTION -->
            <ng-template pTemplate="caption">
                <div class="p-d-flex p-ai-center p-jc-between">
                    <h5 class="p-m-0">{{translations.lbl_school_prep_guides}} -
                        {{ globalUserDataFormParams.get('selectedFinalCoord').value?.descri || (translations.lbl_without
                        + ' ' +
                        translations.lbl_coordination + ' ' + translations.lbl_select) }}
                    </h5>

                    <span class="p-input-icon-left">
                        <i class="pi pi-search"></i>
                        <input pInputText type="text" (input)="dt.filterGlobal($event.target.value, 'contains')"
                            placeholder="{{translations.lbl_search}}..." />
                    </span>
                </div>
            </ng-template>

            <!-- HEADER -->
            <ng-template pTemplate="header">
                <tr>
                    <th pSortableColumn="schoolFPG.schoolId" pTooltip="{{ translations.lbl_id }}">
                        {{ translations.lbl_id }}<p-sortIcon field="schoolFPG.schoolId"></p-sortIcon>
                    </th>
                    <th pSortableColumn="schoolFPG.year" pTooltip="{{ translations.lbl_period }}">
                        {{ translations.lbl_period }}<p-sortIcon field="schoolFPG.year"></p-sortIcon>
                    </th>
                    <th pSortableColumn="schoolFPG.name" pTooltip="{{ translations.lbl_name }}">
                        {{ translations.lbl_name }}<p-sortIcon field="schoolFPG.name"></p-sortIcon>
                    </th>
                    <th pSortableColumn="churchName" pTooltip="{{ translations.lbl_place }}">
                        {{ translations.lbl_place }}<p-sortIcon field="churchName"></p-sortIcon>
                    </th>
                    <th pSortableColumn="guideName" pTooltip="{{ translations.lbl_guide_imparts }}">

                        {{ translations.lbl_guide_imparts }}<p-sortIcon field="guideName"></p-sortIcon>
                    </th>
                    <th pSortableColumn="statusName" pTooltip="{{ translations.lbl_status }}">
                        {{ translations.lbl_status }}<p-sortIcon field="statusName"></p-sortIcon>
                    </th>
                    <th pSortableColumn="schoolFPG.planedDate" pTooltip="{{ translations.lbl_planned_date }}">

                        {{ translations.lbl_planned_date }}<p-sortIcon field="schoolFPG.planedDate"></p-sortIcon>
                    </th>
                    <th pSortableColumn="storeName" pTooltip="{{ translations.lbl_coordination }}">

                        {{ translations.lbl_coordination }}<p-sortIcon field="storeName"></p-sortIcon>
                    </th>
                </tr>
            </ng-template>

            <!--BODY -->
            <ng-template pTemplate="body" let-data>
                <tr>
                    <td pTooltip="{{ data.schoolFPG?.schoolId || '-' }}">{{ data.schoolFPG?.schoolId || '-' }}</td>
                    <td pTooltip="{{ data.schoolFPG?.year || '-' }} - {{ data.schoolFPG?.period || '-' }}">
                        {{ data.schoolFPG?.year || '-' }} - {{ data.schoolFPG?.period || '-' }}
                    </td>
                    <td pTooltip="{{ data.schoolFPG?.name || '-' }}">{{ data.schoolFPG?.name || '-' }}</td>
                    <td pTooltip="{{ data.churchName || '-' }}">{{ data.churchName || '-' }}</td>
                    <td pTooltip="{{ data.guideName || '-' }}">{{ data.guideName || '-' }}</td>
                    <td pTooltip="{{ data.statusName || '-' }}">{{ data.statusName || '-' }}</td>
                    <td pTooltip="{{ data.schoolFPG?.planedDate ? formatDate(data.schoolFPG.planedDate) : '-' }}">
                        {{ data.schoolFPG?.planedDate ? formatDate(data.schoolFPG.planedDate) : '-' }}
                    </td>
                    <td pTooltip="{{ data.storeName || '-' }}">{{ data.storeName || '-' }}</td>
                </tr>

                <!-- SUB TABLE -->
                <tr>
                    <td colspan="1"></td>
                    <td colspan="7" class="sub-table-container">
                        <table class="small-table" responsive="true" [formGroup]="globalUserDataFormParams">
                            <!-- HEADER SUB TABLE-->
                            <thead>
                                <tr>
                                    <th pTooltip="{{ 'Seleccionar' }}" data-label="{{  translations.lbl_select + ' ' + translations.lbl_stage + ' ' +
                                        translations.lbl_to + ' ' + translations.lbl_add }}">
                                        {{ translations.lbl_select + ' ' + translations.lbl_stage + ' ' +
                                        translations.lbl_to + ' ' + translations.lbl_add }}</th>
                                    <th pTooltip="{{ translations?.lbl_stage }}"
                                        data-label="{{ translations?.lbl_stage }}">{{
                                        translations.lbl_stage }}</th>
                                    <th pTooltip="{{ translations.lbl_id }}" data-label="{{ translations.lbl_id }}">{{
                                        translations.lbl_id }}</th>
                                    <th pTooltip="{{ translations.lbl_starting_date }}"
                                        data-label="{{ translations.lbl_starting_date }}">{{
                                        translations.lbl_starting_date }}</th>
                                    <th pTooltip="{{ translations.lbl_status }}"
                                        data-label="{{ translations.lbl_status }}">{{ translations.lbl_status }}
                                    </th>
                                </tr>
                            </thead>

                            <!-- BODY SUB TABLE -->
                            <tbody>

                                <ng-container *ngIf="data.wrks01 || data.wrks02 || data.wrks03; else emptyMessage">

                                    <!-- ROW FOR STAGE I -->
                                    <tr *ngIf="data.wrks01" class="p-mb-4">

                                        <!-- CHEKED -->
                                        <td pTooltip="{{ translations.lbl_select + ' ' + translations.lbl_stage + ' ' +
                                        translations.lbl_to + ' ' + translations.lbl_add }}" [attr.data-label]=" translations.lbl_select + ' ' + translations.lbl_stage + ' ' +
                                        translations.lbl_to + ' ' + translations.lbl_add">
                                            <p-radioButton
                                                *ngIf="data.wrks01?.wrkStatName && !data.wrks01?.wrkStatName.includes('04') && !data.wrks01?.wrkStatName.includes('05')"
                                                [inputId]="data.wrks01?.f0?.wrksId" [value]="data?.wrks01"
                                                formControlName="selectedWorkshopEPG"
                                                (click)="onSelectWorkshop(data.wrks01?.f0?.wrksId)"></p-radioButton>
                                        </td>

                                        <!-- STAGE -->
                                        <td pTooltip="{{ translations.lbl_stage + ' I '  }}"
                                            [attr.data-label]="translations.lbl_stage + ' I ' ">{{
                                            translations.lbl_stage + ' I ' }}
                                        </td>

                                        <!-- ID -->
                                        <td class="align-end" pTooltip="{{ data.wrks01?.f0?.wrksId || '-' }}"
                                            [attr.data-label]="translations?.lbl_id">
                                            {{ data.wrks01?.f0?.wrksId || '-' }}
                                        </td>

                                        <!-- NAME -->
                                        <td class="align-end" pTooltip="{{ data.wrks01?.f0?.strDate || '-' }}"
                                            [attr.data-label]="translations?.lbl_starting_date">
                                            {{ data.wrks01?.f0?.strDate || '-' }}
                                        </td>

                                        <!-- STATUS -->
                                        <td class="align-end" pTooltip="{{ data.wrks01?.wrkStatName || '-' }}"
                                            [attr.data-label]="translations?.lbl_status">
                                            {{ data.wrks01?.wrkStatName || '-' }}
                                        </td>
                                    </tr>

                                    <!-- ROW FOR STAGE II -->
                                    <tr *ngIf="data.wrks02" class="p-mb-4">

                                        <!-- CHEKED -->
                                        <td pTooltip="{{ translations.lbl_select + ' ' + translations.lbl_stage + ' ' +
                                        translations.lbl_to + ' ' + translations.lbl_add }}" [attr.data-label]=" translations.lbl_select + ' ' + translations.lbl_stage + ' ' +
                                        translations.lbl_to + ' ' + translations.lbl_add">
                                            <p-radioButton
                                                *ngIf="data.wrks02?.wrkStatName && !data.wrks02?.wrkStatName.includes('04') && !data.wrks02?.wrkStatName.includes('05')"
                                                [inputId]="data.wrks02?.f0?.wrksId" [value]="data?.wrks02"
                                                formControlName="selectedWorkshopEPG"
                                                (click)="onSelectWorkshop(data.wrks02?.f0?.wrksId)"></p-radioButton>
                                        </td>

                                        <!-- STAGE -->
                                        <td pTooltip="{{ translations.lbl_stage + ' II ' }}"
                                            [attr.data-label]="translations.lbl_stage + ' II '">{{
                                            translations.lbl_stage + ' II '}}</td>

                                        <!-- ID -->
                                        <td class="align-end" pTooltip="{{ data.wrks02?.f0?.wrksId || '-' }}"
                                            [attr.data-label]="translations?.lbl_id">
                                            {{ data.wrks02?.f0?.wrksId || '-' }}
                                        </td>

                                        <!-- NAME -->
                                        <td class="align-end" pTooltip="{{ data.wrks02?.f0?.strDate || '-' }}"
                                            [attr.data-label]="translations?.lbl_starting_date">
                                            {{ data.wrks02?.f0?.strDate || '-' }}
                                        </td>

                                        <!-- STATUS -->
                                        <td class="align-end" pTooltip="{{ data.wrks02?.wrkStatName || '-' }}"
                                            [attr.data-label]="translations?.lbl_status">
                                            {{ data.wrks02?.wrkStatName || '-' }}
                                        </td>
                                    </tr>

                                    <!-- ROW FOR STAGE III -->
                                    <tr *ngIf="data.wrks03" class="p-mb-4">

                                        <!-- CHEKED -->
                                        <td pTooltip="{{ translations.lbl_select + ' ' + translations.lbl_stage + ' ' +
                                        translations.lbl_to + ' ' + translations.lbl_add }}" [attr.data-label]=" translations.lbl_select + ' ' + translations.lbl_stage + ' ' +
                                        translations.lbl_to + ' ' + translations.lbl_add">
                                            <p-radioButton
                                                *ngIf="data.wrks03?.wrkStatName && !data.wrks03?.wrkStatName.includes('04') && !data.wrks03?.wrkStatName.includes('05')"
                                                [inputId]="data.wrks03?.f0?.wrksId" [value]="data?.wrks03"
                                                formControlName="selectedWorkshopEPG"
                                                (click)="onSelectWorkshop(data.wrks03?.f0?.wrksId)"></p-radioButton>
                                        </td>

                                        <!-- STAGE -->
                                        <td pTooltip="{{  translations.lbl_stage + ' III ' }}"
                                            [attr.data-label]=" translations.lbl_stage + ' III '">{{
                                            translations.lbl_stage + ' II '}}</td>

                                        <!-- ID -->
                                        <td class="align-end" pTooltip="{{ data.wrks03?.f0?.wrksId || '-' }}"
                                            [attr.data-label]="translations?.lbl_id">
                                            {{ data.wrks03?.f0?.wrksId || '-' }}
                                        </td>

                                        <!-- NAME -->
                                        <td class="align-end" pTooltip="{{ data.wrks03?.f0?.strDate || '-' }}"
                                            [attr.data-label]="translations?.lbl_starting_date">
                                            {{ data.wrks03?.f0?.strDate || '-' }}
                                        </td>

                                        <!-- STATUS -->
                                        <td class="align-end" pTooltip="{{ data.wrks03?.wrkStatName || '-' }}"
                                            [attr.data-label]="translations?.lbl_status">
                                            {{ data.wrks03?.wrkStatName || '-' }}
                                        </td>
                                    </tr>
                                </ng-container>
                            </tbody>

                            <!-- EMPTY MESSAGE -->
                            <ng-template #emptyMessage>
                                <tr>
                                    <td colspan="6" class="text-center">
                                        {{ translations?.lbl_no_records_found }}
                                    </td>
                                </tr>
                            </ng-template>
                        </table>
                    </td>
                </tr>
            </ng-template>

            <!-- EMPTY -->
            <ng-template pTemplate="emptymessage" let-columns>
                <tr>
                    <td [attr.colspan]="columns ? columns.length : 1">
                        {{translations.lbl_no_records_found}}
                    </td>
                </tr>
            </ng-template>

            <!-- SUMMARY -->
            <ng-template pTemplate="summary">
                <div class="p-d-flex">
                    <span class="p-mr-2">{{ translations.lbl_total }}</span>
                    <span class="p-text-bold p-mr-2">
                        {{ (globalUserDataFormParams.get('selectedLstEpgByFinalCord').value).length || 0 }}
                    </span>
                    <span>{{ translations.lbl_records }}</span>
                </div>
            </ng-template>
        </p-table>
    </div>
</div>

<!-- CONFIRMATION DIALOG -->
<p-dialog [header]="'¿ ' + (translations?.lbl_are_you_sure || '') + ' ' + 
(translations?.lbl_of || '') + ' ' + 
(translations?.lbl_transfer || '') + ' ' + 
(translations?.lbl_of || '') + ' ' + 
(translations?.lbl_future_guide || '') + ' ?'" [(visible)]="displayModalConfirmation" styleClass="p-fluid"
    [modal]="true" [style]="{width: '50vw'}" [maximizable]="true" [baseZIndex]="10000" [draggable]="false"
    [resizable]="false">

    <div class="card">
        <!-- MAIN CONTENT -->
        <div class="p-grid">

            <!-- Coordinación Destino -->
            <div class="p-col-12 p-md-12">
                <div class="p-fluid">

                    <!-- CHURCH INFO -->
                    <div class="subTitle p-d-flex p-ai-center p-jc-between p-py-2">
                        <span>{{ translations.lbl_church }}</span>
                        <ng-container
                            *ngIf="globalUserDataFormParams.get('selectedWorkshopEPGSchoolFpg').value != null && globalUserDataFormParams.get('selectedWorkshopEPG').value != null && globalUserDataFormParams.get('selectedWorkshopEPGSchoolFpg').value != null; else noSelectionChurchFinal">
                            <span class="p-text-bold">
                                {{
                                globalUserDataFormParams.get('selectedWorkshopEPGSchoolFpg').value.schoolFPG?.schoolId
                                || " " }}
                                -
                                {{
                                globalUserDataFormParams.get('selectedWorkshopEPGSchoolFpg').value.schoolFPG?.name
                                || " " }} -
                                {{ globalUserDataFormParams.get('selectedWorkshopEPG').value.chr?.name || " " }}
                            </span>
                        </ng-container>

                        <ng-template #noSelectionChurchFinal>
                            <span class="p-text-bold">{{ translations.lbl_without + ' ' + translations.lbl_place + '
                                ' +
                                translations.lbl_and + '/' + translations.lbl_or + ' ' + translations.lbl_church + '
                                ' +
                                translations.lbl_select}}</span>
                        </ng-template>
                    </div>

                    <!-- SERVICE INFO -->
                    <div class="subTitle p-d-flex p-ai-center p-jc-between p-py-2">
                        <span>{{ translations.lbl_workshop }}</span>
                        <ng-container
                            *ngIf="globalUserDataFormParams.get('selectedWorkshopEPG').value != null  && globalUserDataFormParams.get('selectedWorkshopEPGSchoolFpg').value  != null; else noSelectionServiceFinal">
                            <span class="p-text-bold">
                                {{ globalUserDataFormParams.get('selectedWorkshopEPGSchoolFpg').value.schoolFPG?.name ||
                                " " }} -
                                {{ globalUserDataFormParams.get('selectedWorkshopEPG').value?.f0?.wrksId || " " }}
                                {{ globalUserDataFormParams.get('selectedWorkshopEPG').value?.wst?.wsName || " " }}
                            </span>
                        </ng-container>

                        <ng-template #noSelectionServiceFinal>
                            <span class="p-text-bold">{{ translations.lbl_without + ' ' + translations.lbl_service +
                                ' ' +
                                translations.lbl_select}}</span>
                        </ng-template>
                    </div>

                    <!-- GUIDE ID INFO -->
                    <div class="subTitle p-d-flex p-ai-center p-jc-between p-py-2">
                        <span>{{ translations.lbl_guideId }}</span>
                        <ng-container
                            *ngIf="globalUserDataFormParams.get('selectedFutureGuide').value != null; else noSelectionGuideFinal">
                            <span class="p-text-bold">
                                {{ globalUserDataFormParams.get('selectedFutureGuide').value?.guideId || " " }} -
                                {{ globalUserDataFormParams.get('selectedFutureGuide').value?.name || " " }} -
                                {{ globalUserDataFormParams.get('selectedFutureGuide').value?.lastName || " " }}
                            </span>
                        </ng-container>

                        <ng-template #noSelectionGuideFinal>
                            <span class="p-text-bold">{{ translations.lbl_without + ' ' + translations.lbl_guide + '
                                ' +
                                translations.lbl_select}}</span>
                        </ng-template>
                    </div>

                    <!-- PERIOD & YEAR INFO -->
                    <div class="subTitle p-d-flex p-ai-center p-jc-between p-py-2">
                        <span>{{ translations.lbl_period }}</span>
                        <ng-container
                            *ngIf="globalUserDataFormParams.get('selectedWorkshopEPG').value != null  && globalUserDataFormParams.get('selectedWorkshopEPGSchoolFpg').value != null; else noSelectionYearFinal">
                            <span class="p-text-bold">
                                {{ globalUserDataFormParams.get('selectedWorkshopEPG').value?.f0?.anio || " " }} -
                                {{ globalUserDataFormParams.get('selectedWorkshopEPG').value?.f0?.period || " " }}
                            </span>
                        </ng-container>

                        <ng-template #noSelectionYearFinal>
                            <span class="p-text-bold">{{ translations.lbl_without + ' ' + translations.lbl_period +
                                ' ' +
                                translations.lbl_and + '/' + translations.lbl_or + ' ' + translations.lbl_year + ' '
                                +
                                translations.lbl_select}}</span>
                        </ng-template>
                    </div>
                </div>
            </div>
        </div>

        <!-- INPUTS -->
        <div class="p-grid" formGroup="globalUserDataFormParams">
            <!-- 1ST SECTION INFO -->
            <div class="p-col-12">

                <div class="p-fluid">

                    <!-- Comments -->
                    <div class="p-col-12">
                        <label for="commentsModal">{{translations.lbl_comments}} <span
                                *ngIf="globalUserDataFormParams.get('selectedCommentsTransfer').value == null"
                                style="color:red">
                                (*)</span></label>
                        <textarea id="commentsModal"
                            [formControl]="globalUserDataFormParams.get('selectedCommentsTransfer')" rows="5" cols="30"
                            pInputTextarea autoResize="autoResize" maxlength="300" #myInput></textarea>
                        <label class="nopadding clrlbl">{{myInput.value.length}} / 300 </label>
                    </div>

                </div>
            </div>
        </div>
    </div>

    <ng-template pTemplate="footer">
        <button pButton pRipple label="{{translations.lbl_go_Back}}" icon="pi pi-chevron-left"
            class="p-button-warning p-mr-2" (click)="displayModalConfirmation=false"></button>

        <button pButton pRipple type="button" icon="pi pi-check" label="{{translations.lbl_accept}}"
            class="p-button-raised p-button-success" (click)="transferGuideToNewCoordination()"></button>
    </ng-template>
</p-dialog>